import { UserPermissionLevel } from 'constants/auth';

export const statusFilterOptions = [
  { value: 'all', label: 'All' },
  { value: 'Upcoming', label: 'Upcoming' },
  { value: 'Complete', label: 'Complete' },
  {
    value: 'Draft',
    label: 'Draft',
    permissionLevel: UserPermissionLevel.Official,
  },
];

export const viewTypeOptions = [];

export const columns = [
  {
    accessor: 'date',
    label: 'Date & Time',
    // sortable: true,
    headerStyle: {
      paddingLeft: 20,
      paddingRight: 20,
    },
    style: {
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
  {
    accessor: 'meetName',
    label: 'Meet Name',
    headerStyle: {
      paddingLeft: 20,
      paddingRight: 20,
    },
    style: {
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
  {
    accessor: 'location',
    label: 'Location',
    headerStyle: {
      paddingLeft: 20,
      paddingRight: 20,
    },
    style: {
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
  {
    accessor: 'age',
    label: 'Athletes',
    headerStyle: {
      paddingLeft: 20,
      paddingRight: 20,
    },
    style: {
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
  {
    accessor: 'countsForPoints',
    label: 'Counts for Points',
    headerStyle: {
      paddingLeft: 20,
      paddingRight: 20,
      textAlign: 'center',
    },
    style: {
      paddingLeft: 20,
      paddingRight: 20,
      textAlign: 'center',
    },
  },
  {
    accessor: 'countsForBests',
    label: 'Counts for Season Bests',
    headerStyle: {
      paddingLeft: 20,
      paddingRight: 20,
      textAlign: 'center',
    },
    style: {
      paddingLeft: 20,
      paddingRight: 20,
      textAlign: 'center',
    },
  },
  {
    accessor: 'statusBadge',
    label: 'Status',
    headerStyle: {
      paddingLeft: 20,
      paddingRight: 20,
      textAlign: 'center',
    },
    style: {
      paddingLeft: 20,
      paddingRight: 20,
      textAlign: 'center',
    },
  },
  {
    accessor: 'buttons',
    label: '',
    headerStyle: {
      paddingLeft: 20,
      paddingRight: 20,
    },
    style: {
      paddingLeft: 20,
      paddingRight: 20,
    },
  },
];
